import React from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import cs from 'classnames';

type TUnitPriceBadgeProps = {
    unitPrice: string;
    className?: string;
};

export const UnitPriceBadge = (props: TUnitPriceBadgeProps) => {
    const {unitPrice, className} = props;

    return (
        <div className={cs(className, style.label)}>
            <Typography variant={'label-12-r'}>Цена за штуку {unitPrice}</Typography>
        </div>
    );
};
